// event_bus.js
import Vue from 'vue';

const EventBus = new Vue();

export default EventBus;


// WEBPACK FOOTER //
// ./src/js/event_bus.js